import { render } from "./dealer_clerkAdd.vue?vue&type=template&id=1c230117&scoped=true"
import script from "./dealer_clerkAdd.vue?vue&type=script&lang=js"
export * from "./dealer_clerkAdd.vue?vue&type=script&lang=js"

import "./dealer_clerkAdd.vue?vue&type=style&index=0&id=1c230117&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c230117"]])

export default __exports__